import React, { useState } from 'react';
import {
  Typography,
  Card,
  CardContent,
  Box,
  Tabs,
  Tab,
  Grid,
  Backdrop,
  CircularProgress,
  AppBar,
  Container
} from '@material-ui/core';
import { useClientContext } from '../../context/client_context';
import { useClaimsContext } from '../../context/claims_context';
import Controls from '../controls/Controls';
import OnlineClaimsVet from './OnlineClaimsVet';
import { OnlineClaimsDocs } from './OnlineClaimsDocs';

export default function OnlineProcessVet() {
  const tenant = sessionStorage.getItem('userRefId');
  const [index, setIndex] = useState(0);
  const { claimNo } = useClaimsContext();
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });

  console.log('Number(tenant)', Number(tenant));
  const onTabClicked = (event, index) => {
    setIndex(index);
  };

  const Panel = (props) => <div hidden={props.value !== props.index}>{props.children}</div>;

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  return (
    <Container>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid margin={2} container spacing={2} direction="row">
        <Grid item xs={3} sm={3} mr={2}>
          <Typography component="span" variant="h6" gutterBottom>
            Process Self Online Claims
          </Typography>
        </Grid>
      </Grid>
      <Card>
        <CardContent>
          <AppBar position="static" color="darkblack">
            <Tabs
              value={index}
              indicatorColor="primary"
              // textColor="white"
              onChange={onTabClicked}
              aria-label="simple tabs example"
            >
              <Tab label="Online Claim" />
              <Tab label="Documents" />
            </Tabs>
          </AppBar>
          <Box>.</Box>
          <Panel value={index} index={0}>
            <OnlineClaimsVet />
          </Panel>
          <Panel value={index} index={1}>
            <OnlineClaimsDocs refId="999" />
          </Panel>
        </CardContent>
        <Controls.Notification notify={notify} setNotify={setNotify} />
      </Card>
    </Container>
  );
}
